import {
  getObject,
  getOptionalObject,
  getString,
} from "@surya-digital/leo-ts-types";
import { SurveyLocalizedText, SurveyLocalizedTextDTO } from "../assets/surveyLocalizedText";

export interface GridRowResponseV1DTO {
  rowOptionText?: SurveyLocalizedTextDTO | null;
  answer: string;
}

export class GridRowResponseV1 {
  readonly isGridRowResponseV1GridRowResponseV1: boolean = true;

  readonly rowOptionText: SurveyLocalizedText | null;
  readonly answer: string;


  constructor(
  rowOptionText: SurveyLocalizedText | null = null, 
  answer: string
  ) {
    this.rowOptionText = rowOptionText;
    GridRowResponseV1.validateAnswer(answer);
    this.answer = answer;
  }

  static fromDTO(dto: GridRowResponseV1DTO): GridRowResponseV1 {
    let rowOptionText = getOptionalObject(dto, "rowOptionText");
    if(rowOptionText !== undefined && rowOptionText !== null) {
      rowOptionText = SurveyLocalizedText.fromDTO(getObject(dto, "rowOptionText", InvalidGridRowResponseV1RowOptionTextError));
    }
    const answer = getString(dto, "answer", InvalidGridRowResponseV1AnswerError);
    return new GridRowResponseV1(
      rowOptionText,
      answer
    );
  }

  toDTO(): GridRowResponseV1DTO {
    const dto: GridRowResponseV1DTO = {
        answer: this.answer
    };
    if (this.rowOptionText !== undefined && this.rowOptionText !== null){
      dto.rowOptionText = this.rowOptionText.toDTO();
    }
    return dto;
  }
  private static validateAnswer = (answer: string): void => {
    if(answer.trim().length === 0) {
      throw new InvalidGridRowResponseV1AnswerNonEmptyError(
        `Attribute answer cannot be an empty string.`
      );
    }
  }
  
}

GridRowResponseV1.prototype.toString = function toString(): string {
  return `GridRowResponseV1(rowOptionText='${this.rowOptionText}',answer='${this.answer}')`;
};

export class InvalidGridRowResponseV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridRowResponseV1Error";
  }
}
export class InvalidGridRowResponseV1RowOptionTextError extends InvalidGridRowResponseV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridRowResponseV1RowOptionTextError";
  }
}

export class InvalidGridRowResponseV1AnswerError extends InvalidGridRowResponseV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridRowResponseV1AnswerError";
  }
}

export class InvalidGridRowResponseV1AnswerNonEmptyError extends InvalidGridRowResponseV1AnswerError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridRowResponseV1AnswerNonEmptyError";
  }
}
